export default {
  flashSalesTag: {
    id: 'flash_sales_product_card_tag',
    defaultMessage: '{price} off at checkout',
  },
  competitiveFlashSalesTag: {
    id: 'competitive_price_product_card_tag',
    defaultMessage: 'Great price',
  },
  sellerFlashSalesTag: {
    id: 'seller_flash_sales_product_card_tag',
    defaultMessage: '{percentage} price drop',
  },
} as const
